import { defineMeta } from '@/registry/types';

export const inventoryExampleMeta = defineMeta({
  name: 'InventoryExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference asset inventory page (TablePageLayout + DataTable).',
  baseLibrary: 'custom',
  importPath: '@/pages/InventoryExample',
  supportedStates: ['default'],
  designTokens: ['colors', 'severity'],
  usageExamples: ['<InventoryExample />'],
  llmSafe: false,
  whenToUse: ['Reference for inventory screens'],
  whenNotToUse: ['Production without data wiring'],
});

export default inventoryExampleMeta;
